//  helper functions

const svgIcon = {
  styleOverrides: {
    fontSizeInherit: {
      fontSize: "inherit !important",
    },
  },
};
export default svgIcon;
